/* HuysPlan bouwstenen, gedrag.
   Bron: handoff/02-bouwstenen.md, 2.13 swipebare rij en 2.14 accordeon.
   Besluit 7: pijlknoppen altijd zichtbaar, ook op mobiel. */

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 2.13 Swipebare rij, slepen met de muis ----
     Een klik binnen 6px verplaatsing geldt nog als klik. Daarboven is het
     slepen en onderdrukken we de klik, anders open je per ongeluk een product. */
  document.querySelectorAll('.hp-rail').forEach(function (rail) {
    var actief = false, startX = 0, startScroll = 0, verplaatst = 0;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      actief = true; verplaatst = 0;
      startX = e.clientX; startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!actief) return;
      var dx = e.clientX - startX;
      verplaatst = Math.abs(dx);
      if (verplaatst > 6) rail.classList.add('is-dragging');
      rail.scrollLeft = startScroll - dx;
    });

    function stop() { actief = false; rail.classList.remove('is-dragging'); }

    rail.addEventListener('pointerup', function () {
      if (verplaatst > 6) {
        rail.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
        }, { capture: true, once: true });
      }
      stop();
    });
    rail.addEventListener('pointerleave', stop);
    rail.addEventListener('pointercancel', stop);
  });

  /* ---- 2.12 Pijlknoppen. Scrollen een heel aantal kaarten op of terug. ----
     De kaarten schalen mee met de rijbreedte (zie .hp-rail > * in
     hp-components.css), dus een stap van perView kaarten landt altijd
     precies op een kaartrand en nooit middenin een kaart. */
  document.querySelectorAll('[data-hp-arrow]').forEach(function (knop) {
    knop.addEventListener('click', function () {
      var houder = knop.closest('[data-hp-railwrap]');
      var rail = houder && houder.querySelector('.hp-rail');
      if (!rail) return;
      var eerste = rail.firstElementChild;
      var kaart = eerste ? eerste.getBoundingClientRect().width : rail.clientWidth;
      var stijl = getComputedStyle(rail);
      var tussen = parseFloat(stijl.columnGap || stijl.gap) || 0;
      var perView = Math.max(1, Math.round((rail.clientWidth + tussen) / (kaart + tussen)));
      var stap = perView * (kaart + tussen);
      var richting = knop.getAttribute('data-hp-arrow') === 'prev' ? -1 : 1;
      rail.scrollBy({ left: stap * richting, behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  /* ---- Toevoegen aan winkelwagen zonder ernaartoe te springen. ----
     Verzoek 20 augustus: elke koopknop op de productpagina (hoofdformulier,
     "vaak samen gekocht", "maak je set compleet") gebruikt Shopify's
     {% form 'product' %}, die standaard naar /cart/add post en daarna
     doorstuurt naar de winkelwagen. Daardoor kon je niet doorklikken naar
     een andere productpagina. Dit onderschept elk formulier dat naar
     /cart/add post, voegt toe via de AJAX-route, en blijft op de pagina.
     e.submitter (niet form.querySelector) omdat de sticky koopbalk op
     mobiel een knop buiten het formulier heeft, gekoppeld via form="...".

     Staat het vinkje "Extra erbij" aan (data-hp-addon met data-varid), dan
     gaan hoofdproduct en extra-product samen in een JSON-verzoek, zodat het
     extra ook echt als eigen regel wordt afgerekend. De properties-notitie
     gaat dan niet mee; die is alleen de terugval zonder JavaScript.

     De ronde plusknoppen (.hp-samen__add, .hp-up__add) zijn maar 40px en
     hebben alleen ruimte voor één teken: die krijgen een kort ✓/! in plaats
     van de volledige tekst, anders loopt "Toegevoegd" uit de cirkel. */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var knop = e.submitter || form.querySelector('button[type="submit"]');
      var rond = knop && (knop.classList.contains('hp-samen__add') || knop.classList.contains('hp-up__add'));
      var oorspronkelijk = knop ? knop.textContent : null;
      if (knop) {
        knop.disabled = true;
        if (!rond) knop.textContent = 'Toevoegen…';
      }

      var fd = new FormData(form);
      var addon = form.querySelector('[data-hp-addon]');
      var verzoek;
      if (addon && addon.checked && addon.getAttribute('data-varid')) {
        verzoek = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [
            { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 },
            { id: parseInt(addon.getAttribute('data-varid'), 10), quantity: 1 }
          ] })
        });
      } else {
        verzoek = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        });
      }

      verzoek
        .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'add failed'); }); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('.hph__cartn').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
          if (knop) knop.textContent = rond ? '✓' : 'Toegevoegd ✓';
        })
        .catch(function () {
          if (knop) knop.textContent = rond ? '!' : 'Kon niet toevoegen';
        })
        .finally(function () {
          setTimeout(function () {
            if (knop) { knop.disabled = false; knop.textContent = oorspronkelijk; }
          }, 1600);
        });
    });
  });

  /* ---- 2.14 Accordeon. Alles staat dicht, er is altijd maximaal een open. ---- */
  document.querySelectorAll('.hp-acc').forEach(function (acc) {
    acc.querySelectorAll('.hp-acc__head').forEach(function (kop) {
      kop.addEventListener('click', function () {
        var paneel = kop.nextElementSibling;
        var stondOpen = paneel.classList.contains('is-open');

        acc.querySelectorAll('.hp-acc__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
        acc.querySelectorAll('.hp-acc__head').forEach(function (h) { h.setAttribute('aria-expanded', 'false'); });

        if (!stondOpen) {
          paneel.classList.add('is-open');
          kop.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
})();
